import { BeneficiariesRoute } from '@/routes/BeneficiariesRoute'
import { ErrorRoute } from '@/routes/ErrorRoute'
import { createBrowserRouter } from 'react-router-dom'
import { Root } from './Root'

export const router = () =>
  createBrowserRouter([
    {
      path: '/',
      element: <Root />,
      errorElement: <ErrorRoute />,
      children: [
        {
          path: beneficiariesPath,
          element: <BeneficiariesRoute />,
        },
      ],
    },
  ])

export enum RouteNames {
  Beneficiaries = 'beneficiaries',
  Root = '/',
}

const beneficiariesPath = '/' + RouteNames.Beneficiaries + '/:beneficiaryId'

export enum SearchParamsKeyNames {
  Source = 'source',
}

export enum SearchParamsViewNames {
  QrCode = 'qr-code',
}

export const buildRoute = (
  routeName: RouteNames,
  params: string | string[],
): string => {
  return `/${routeName}/${typeof params === 'string' ? params : params.join('/')}`
}

export const buildSearchParam = (
  searchParamsKey: string,
  keyName: SearchParamsViewNames,
): string => {
  return `?${searchParamsKey}=${keyName}`
}
